import Loader from "chameleon/icons/loader";

import {
  loaderContainer,
  loadingClass,
  loadingWrapperStyles,
} from "./loading-spinner.css";

export interface LoadingSpinnerProps {
  /**
   * Size Variant (in px)
   */
  sizeVariant?: 32 | 24 | 16;
}

/**
 * General Loading State display
 * (Note: the color is set by its parent container via currentColor in the Loading icon)
 */
export const LoadingSpinner = ({ sizeVariant = 32 }: LoadingSpinnerProps) => {
  return (
    <div
      role={"img"}
      aria-label="loading spinner"
      className={`${loadingClass} ${loadingWrapperStyles({
        sizeVariant: `${sizeVariant}`,
      })}`}
    >
      <Loader sizeVariant={sizeVariant} />
    </div>
  );
};

export const LoadingSpinnerWrapped = ({
  sizeVariant = 32,
}: LoadingSpinnerProps) => {
  return (
    <div className={loaderContainer}>
      <div
        role={"img"}
        aria-label="loading spinner"
        className={`${loadingClass} ${loadingWrapperStyles({
          sizeVariant: `${sizeVariant}`,
        })}`}
      >
        <Loader sizeVariant={sizeVariant} />
      </div>
    </div>
  );
};
